import template from './charts-overview.hbs'
import ChartsView from './charts-view'

const ChartsOverview = ChartsView.extend({
	className: 'display-layout table-hack charts-overview',
	subsection: 'overview',
	deferredReady: true,

	/**
	 * @override
	 */
	renderSubsection: function (container) {
		container.append(template())
	},

	/**
	 * @override
	 */
	 renderChart: function(dimensions, emphasize = null) {
	 	ChartsView.prototype.renderChart.apply(this, arguments)

		if (this.chart) {
			// #48807 wait for the chartViewObject itself to be rendered before
			// indicating that it's ready for export
			this.chart.on('rendered', () => this.trigger('ready'))
		} else {
			// If this.chart is null, the chart didn't render successfully
			// (possibly due to validation errors), so just say it's ready
			this.trigger('ready')
		}
	 },

	/**
	 * @override
	 */
	fetchOptions: function () {
		return {
			chartId: this.model.id
		}
	}
})

export default ChartsOverview

ChartsOverview.__filename__ = 'charts/charts-overview.js'
